import Layout from '@/layout/layout'

const classificationRouter = {
    path: '/lowPhonemanagement',
    component: Layout,
    redirect: 'noRedirect',
    name: '低端机管理',
    children: [
        {
            path: 'functionalItem',
            component: () => import('@/views/lowPhonemanagement/functionalItem/index'),
            name: '低端机功能项配置',
            meta: { title: '低端机功能项配置', noCache: true }
        },
        {
            path: 'sampleGraph',
            component: () => import('@/views/lowPhonemanagement/sampleGraph/index'),
            name: '低端机示例图配置',
            meta: { title: '低端机示例图配置', noCache: true }
        },
        {
            path: 'RecyclersOutModel',
            component: () => import('@/views/lowPhonemanagement/RecyclersOutModel/index'),
            name: '物流申请',
            meta: { title: '物流申请', noCache: true }
        },
    ]
}

export default classificationRouter